import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { BaseDataService } from "./base-data-service";
import { AppConfigService } from "@tmhcc-ng-lib/global-services";
import { CopyQuoteResponse, CopyQuoteRequest } from "./def/copy-quote";
import { CopyQuoteModel } from "@tmhcc-ng-lib/models";
@Injectable()
export class CopyQuoteService extends BaseDataService {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService);
  }
  createCopyQuote(payload: CopyQuoteRequest): Observable<CopyQuoteModel> {
    const url = `${this.serviceBaseUrl}/CopyQuote`;
    return this.post<CopyQuoteResponse>(url, { body: payload })
      .pipe
      ();
  }
}
